<template>
    <div class="flat-index">
        <div class="fi-mobile">
            <fi-header-mobile :is-mark="oMark"></fi-header-mobile>
            <div class="aboutus-mobile">
                <div class="item">
                    <div class="ab-title">
                        <h1>01</h1>
                        <div class="ab-text">
                            <h2>关于点点</h2>
                            <p>Online Service</p>
                        </div>
                    </div>
                    <div class="ab-content">
                        <p>
                            点击在线咨询按钮，连接人工客服。
                        </p>
                    </div>
                    <div class="online-btn">
                        <a href="https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网">在线咨询</a>
                    </div>
                </div>
                <div class="item">
                    <div class="ab-title">
                        <h1>02</h1>
                        <div class="ab-text">
                            <h2>常见问题</h2>
                            <p>Common Problem</p>
                        </div>
                    </div>
                    <div class="help-list">
                        <ul>
                            <li @click="clickHelpListHandle(index)" v-for="(item,index) in helpList" :key="index">
                                <h2>{{item.title}}</h2>
                                <div class="help-item" :class="{'active':activeArr[index]}">
                                    <!-- <h4>申请需求哪些流程？</h4> -->
                                    <p v-html="item.content"></p>
                                </div>
                                <div class="arrow" :class="{'acitve':activeArr[index]}"></div>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="item">
                    <div class="ab-title">
                        <h1>03</h1>
                        <div class="ab-text">
                            <h2>获取支持</h2>
                            <p>Get Support</p>
                        </div>
                    </div>
                    <div class="ab-content">
                        <p>
                            客服热线：4000666122(工作日9:00-18:00)
                        </p>
                    </div>
                </div>
                <div class="item">
                    <div class="ab-title">
                        <h1>04</h1>
                        <div class="ab-text">
                            <h2>意见反馈</h2>
                            <p>Suggestions</p>
                        </div>
                    </div>
                    <div class="suggestions">
                        <input v-model="title" placeholder="请输入您的问题" type="text">
                        <textarea v-model="content" placeholder="请输入您的问题描述"></textarea>
                        <button type="button" @click="sendHandle" name="button">提交</button>
                    </div>
                </div>
            </div>
            <fi-footer-mobile :is-adv="false"></fi-footer-mobile>
            <fi-mark :is-mark="oMark"></fi-mark>
        </div>
    </div>
</template>
<script>
import {
    os
} from '../utils/tool'
import FiMark from '../components/fimark'
import FiFooterMobile from '../components/footerMobile'
import FiHeaderMobile from '../components/headerMobile'
import api from '../api/axios'

export default {
    components: {
        FiMark,
        FiFooterMobile,
        FiHeaderMobile
    },
    data() {
        const _vue = this;
        return {
            isPc: false,
            isMobile: false,
            helpList:[
                {
                    title:'点点是什么？',
                    content:'点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务，已与国内众多知名金融机构达成深度合作。'
                },
                {
                    title:'借点的申请条件是？',
                    content:'点点面向全国开放，只要持有中国第二代居民身份证、储蓄卡且年龄在21岁至55岁即可申请。'
                },
                {
                    title:'申请借点需要哪些流程？',
                    content:'1. 手机注册登录<br />2. 填写个人资料，进行信用评估（额度实时评估）。请确保信息真实有效，上传信息已经过技术加密，请放心填写。<br />3. 选择借款金额及期限申请提现，资金会自动放款至绑定的信用卡或银行卡中。部分用户会有工作人员与您电话沟通审核，请注意021开头的来电。'
                },
                {
                    title:'申请借点需要哪些材料？',
                    content:'1. 身份证<br />2. 信用卡、银行卡（借记卡非Ⅱ类卡）温馨提示：绑定储蓄卡不能为II类户。绑定II类户下的储蓄卡将会影响您的借款申请。如需确认储蓄卡是否为II类户，请致电开卡行客服确认。'
                },
                {
                    title:'借点如何还款？',
                    content:'您在借款时需要绑定储蓄卡，点点默认在到期还款日从您的储蓄卡中扣除当期应还款项。请确保在还款日当日晚6点前还款卡中余额充足。您也可以通过登录点点App，发起主动还款。'
                },
                {
                    title:'如何查询交易记录/账单？',
                    content:'如您已成功申请借款，您可以在登录点点APP之后点击右上角图标，点击【交易记录】，了解您的借款及还款情况。'
                },
                {
                    title:'商城的商品是从哪里进货的？是真品和正品吗？',
                    content:'商城的商品有双重正品权益保障：<br />1、点点只会向金融机构或上市公司签约的供应商采购并销售商品，且每月对供应商的商品质量做抽查审核，保障用户的权益。<br />2、所有商品均由众安保险提供《正品交易履约保证保险》，对于认证的非正品商品，提供最高上万元的赔付保障。'
                },
                {
                    title:'如何保障我的资金安全？',
                    content:'在安全保障方面我们采用最为先进的安全技术，并且所有信息均为加密存储，保证信息交换及存储过程的安全性，保护您的信息安全。'
                },
                {
                    title:'如何注销账户？',
                    content:'申请注销账户之前，请确保您注销账户前需保证您在点点上购买的商品、享受的服务等已终止，且不存在对点点或交易相对方应承担的违约或侵权责任。符合以上条件，可以通过电话客服咨询相关注销事宜，由工作人员协助解决。'
                }
            ],
            activeArr:[],
            cfNum:-1,
            title:'',
            content:'',
            oMark:{
                show:false
            },
        }
    },
    mounted() {
        document.title="帮助中心"

    },
    methods: {
        sendHandle() {
            if (!this.$storage.getItem('user').accessKey) {
                this.$toast({
                    msg: '请先登录账号'
                })
                return
            }
            if (this.title.trim() == '') {
                this.$toast({
                    msg: '请输入您的问题'
                })
                return
            }
            if (this.content.trim() == '') {
                this.$toast({
                    msg: '请输入您的问题描述'
                })
                return
            }
            this.$loading()
            api.axios({
                id: 'userAPI.feedBackQuestion',
                param: {
                    title: this.title,
                    content: this.content,
                    'accessKey': this.$storage.getItem('user').accessKey,
                    'userId': this.$storage.getItem('user').userId,
                    'thirdUserNo': this.$storage.getItem('user').thirdUserNo,
                }
            }).then((res) => {
                this.$loading.end()
                let data = res.data
                if (data.status == "SUCCESS") {
                    this.$toast({
                        msg: '提交成功'
                    })
                    this.title = ''
                    this.content = ''
                } else {
                    this.$toast({
                        msg: '查询接口失败'
                    })
                }
            }).catch((error) => {
                this.$loading.end()
                this.$toast({
                    msg: error.message
                })
            })
        },
        hideMarkHandle(val){
            this.isShow=val
        },
        clickHelpListHandle(index){
            if(this.cfNum1!=index){
                this.activeArr=[]
                this.activeArr[index]=true
                this.cfNum1=index
            }else{
                this.activeArr=[]
                this.activeArr[this.cfNum1]=false
                this.cfNum1=-1
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// HelpCenterMobile.vue?bf7ec60e